/* eslint-disable no-undef */
// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "stimulus"

import Appsignal from 'utils/appsignal';
import { installErrorHandler } from "@appsignal/stimulus"

import FormController from 'controllers/form_controller';
import ExpandableContentController from "controllers/expandable_content_controller";
import CopyToClipboardController from "controllers/copy_to_clipboard_controller";
import VisiblityToggleController from "controllers/visibility_toggle_controller";
import BeaconLinkController from "controllers/beacon_link_controller";
import StripePaymentController from "controllers/stripe_payment_controller";
import ClickTrackerController from "controllers/click_tracker_controller";
import NewTabLinkController from "controllers/new_tab_link_controller";
import TiptapController from "controllers/tiptap_controller";
import TrixNoAttachmentsController from "controllers/trix_no_attachments_controller";
import NavigationController from "controllers/bridge/navigation_controller";
import AddressGeocodePrefillController from "controllers/address_geocode_prefill_controller";
import MenuController from "controllers/bridge/menu_controller";
import IntercomController from "controllers/bridge/intercom_controller";
import { controllers } from "@joemasilotti/bridge-components"

const application = Application.start()

window.Stimulus = application;
// Report errors to appsignal
installErrorHandler(Appsignal, application);

// Whitelist the controllers we want to use.
application.register("form", FormController);
application.register("expandable-content", ExpandableContentController);
application.register("copy-to-clipboard", CopyToClipboardController);
application.register("visibility-toggle", VisiblityToggleController);
application.register("beacon-link", BeaconLinkController);
application.register("stripe-payment", StripePaymentController);
application.register("click-tracker", ClickTrackerController);
application.register("new-tab-link", NewTabLinkController);
application.register("threads-tiptap", TiptapController);
application.register("trix-no-attachments", TrixNoAttachmentsController);
application.register("address-geocode-prefill", AddressGeocodePrefillController);
application.load(controllers); // load package before custom controllers so we can override if needed
application.register("bridge--navigation", NavigationController);
application.register("bridge--intercom", IntercomController);
application.register("bridge--menu", MenuController);


// Still load all the component controllers for now.
import { definitions as contextComponents } from 'stimulus:../../../../components';
application.load(contextComponents);

// Load controllers from the subscriber_v2 engine
import { definitions as contextSubscriberV2 } from 'stimulus:../../../../../engines/subscriber_v2/app/components';
application.load(contextSubscriberV2);

import { definitions as contextSubscriberV2Controllers } from "stimulus:../../../../../engines/subscriber_v2//app/javascript/controllers";
application.load(contextSubscriberV2Controllers);

import { definitions as contextSubscriberV2Namespaced } from "stimulus:../../../../../engines/subscriber_v2//app/components/subscriber_v2";
application.load(contextSubscriberV2Namespaced);

import { definitions as subscriberV2Views } from "stimulus:../../../../../engines/subscriber_v2//app/views/subscriber_v2";
application.load(subscriberV2Views);

